<form [formGroup]="form" class="cemento-tipo-entrega-section">

  <div class="cemento-tipo-entrega-section__field">
    <app-radio-option-group
      controlName="tipoEntrega"
      [options]="tipoEntregaOptions()"
      direction="row"
      [invalid]="form.get('tipoEntrega')?.invalid ?? false"
      [touched]="form.get('tipoEntrega')?.touched ?? false"
      errorMessage="Seleccione un tipo de entrega.">
    </app-radio-option-group>
  </div>

  @if (form.get('tipoEntrega')?.value === TIPO_ENTREGA_DESPACHO && despachoOptions().length > 0) {
    <div class="cemento-tipo-entrega-section__subsection">
      <p class="cemento-tipo-entrega-section__subsection-title">Modalidad de Despacho</p>
      <p class="cemento-tipo-entrega-section__subsection-hint">
        Selecciona cómo se entregan los sacos de cemento en tu obra o dirección.
      </p>
      <app-radio-option-group
        controlName="tipoDespacho"
        [options]="despachoOptions()"
        direction="row">
      </app-radio-option-group>
    </div>
  }

  @if (form.get('tipoEntrega')?.value === TIPO_ENTREGA_RETIRA_CLIENTE) {
    <div class="cemento-tipo-entrega-section__subsection cemento-tipo-entrega-section__plant-info">
      <p class="cemento-tipo-entrega-section__subsection-title">
        Planta o centro de distribución de retiro asignada según tu ubicación
      </p>
      @if (selectedCentro(); as centro) {
        <div class="cemento-tipo-entrega-section__plant-detail">
          <div class="cemento-tipo-entrega-section__plant-row">
            <span class="cemento-tipo-entrega-section__plant-label">Nombre de planta</span>
            <span class="cemento-tipo-entrega-section__plant-value">{{ centro.name }}</span>
          </div>
          <div class="cemento-tipo-entrega-section__plant-row">
            <span class="cemento-tipo-entrega-section__plant-label">Dirección</span>
            <span class="cemento-tipo-entrega-section__plant-value">{{ centro.address_withdrawal }}</span>
          </div>
        </div>
      }
      <p class="cemento-tipo-entrega-section__plant-note">
        El cliente debe contar con el transporte adecuado para realizar el retiro.
      </p>
    </div>

    @if (comunas().length > 0) {
      <div class="cemento-tipo-entrega-section__field mt-3">
        <app-item-direct-select
          formControlName="comuna"
          [items]="comunas()"
          bindLabel="name"
          [compareWith]="compareComunaById"
          placeholder="Seleccione comuna"
          notFoundText="No se encontraron comunas"
          label="Comuna">
        </app-item-direct-select>
        @if (form.get('comuna')?.invalid && form.get('comuna')?.touched) {
          <div class="invalid-feedback d-block">Seleccione una comuna.</div>
        }
      </div>
    }
  }

  @if (!tipoEntregaOptions().length) {
    <div class="text-muted small mt-3">
      No hay tipos de entrega configurados para este producto.
    </div>
  }

</form>
